export default __webpack_public_path__ + "a7ea44567005c758ff04b4fb3c88cc3d.svg";